import { type FC } from "react";

import { SortDropdown } from "~/components/UI/SortDropdown";
import { useSortBy } from "~/feature/dashboard/components/sortAndFilters/SortBy/useSortBy";

import { useSortByOptions } from "./useSortByOptions";

export const SortBy: FC = () => {
  const options = useSortByOptions();
  const { selectedValue, onChangeSort } = useSortBy();

  return (
    <SortDropdown
      label="Sort by"
      options={options}
      value={selectedValue}
      onChange={onChangeSort}
    />
  );
};
